module.exports = __webpack_public_path__ + "static/media/dog-presa-canario.781e29d1.png";